

import { onMounted, reactive, computed } from 'vue'
import { useStore } from 'vuex'  
import { notify } from "@kyvg/vue3-notification";
import {useRouter, useRoute} from 'vue-router' 


export default {
    name: 'privacy',
    components: { 
    },
    
    setup() {

        const store = useStore()  
        const locale = computed(() => store.state.translation.locale) 
        const route = useRoute()

        const data = reactive({ 
            loading: false,
        })


        onMounted(async () => {

            data.loading = true  ;

            

            data.loading = false
        })

        return { 
            data,
            locale, 
        }
    }
}
